import {
  InventoryAdjustmentReason,
  InventoryAdjustmentStatus,
  InventoryAdjustmentType,
} from "@/graphql/codegen/graphql"

export const ADJUSTMENT_TYPE_TO_LABEL: Record<InventoryAdjustmentType, string> = {
  [InventoryAdjustmentType.AdjustQuantity]: "Adjust Quantity",
  [InventoryAdjustmentType.SplitPallets]: "Split Pallets",
  [InventoryAdjustmentType.CombinePallets]: "Combine Pallets",
  [InventoryAdjustmentType.LotBatchCorrection]: "Lot/Batch Correction",
  [InventoryAdjustmentType.AddNewPallets]: "Add New Pallets",
  [InventoryAdjustmentType.As400Adjustment]: "AS400 Adjustment",
} as const

export const ADJUSTMENT_REASON_TO_LABEL: Record<InventoryAdjustmentReason, string> = {
  [InventoryAdjustmentReason.Damage]: "Damage (Material can't be sold)",
  [InventoryAdjustmentReason.Samples]: "Samples (Sent to sample room)",
  [InventoryAdjustmentReason.TollMixing]: "Toll Mixing",
  [InventoryAdjustmentReason.LostMaterial]: "Lost Material",
  [InventoryAdjustmentReason.FoundMaterial]: "Found Material (Not previously in system)",
  [InventoryAdjustmentReason.CustomerReturn]: "Customer Return (Initiatives receiving)",
  [InventoryAdjustmentReason.ExpiredMaterial]: "Expired Material (Shelf life exceeded)",
  [InventoryAdjustmentReason.Other]: "Other",
} as const

export const ADJUSTMENT_STATUS_TO_LABEL: Record<InventoryAdjustmentStatus, string> = {
  [InventoryAdjustmentStatus.Pending]: "Pending",
  [InventoryAdjustmentStatus.WorkOrderPending]: "Work Order Pending",
  [InventoryAdjustmentStatus.PendingSync]: "Pending Sync to AS400",
  [InventoryAdjustmentStatus.Completed]: "Completed",
  [InventoryAdjustmentStatus.PartiallyFailed]: "Partially Failed",
  [InventoryAdjustmentStatus.Failed]: "Failed",
} as const

export const ADJUSTMENT_TYPE_TO_CHIP_CLASS: Record<InventoryAdjustmentType, string> = {
  [InventoryAdjustmentType.AdjustQuantity]: "bg-primary-100 text-primary-600",
  [InventoryAdjustmentType.SplitPallets]: "bg-tertiary-yellow-100 text-tertiary-yellow-900",
  [InventoryAdjustmentType.CombinePallets]: "bg-tertiary-orange-100 text-tertiary-orange-900",
  [InventoryAdjustmentType.LotBatchCorrection]: "bg-tertiary-purple-100 text-tertiary-purple-500",
  [InventoryAdjustmentType.AddNewPallets]: "bg-tertiary-green-100 text-tertiary-green-700",
  [InventoryAdjustmentType.As400Adjustment]: "bg-tertiary-yellow-100 text-tertiary-yellow-900",
} as const

export const ADJUSTMENT_STATUS_TO_CHIP_CLASS: Record<InventoryAdjustmentStatus, string> = {
  [InventoryAdjustmentStatus.Pending]: "bg-gray-200 text-gray-700",
  [InventoryAdjustmentStatus.WorkOrderPending]: "bg-tertiary-yellow-100 text-tertiary-yellow-900",
  [InventoryAdjustmentStatus.PendingSync]: "bg-tertiary-orange-100 text-tertiary-orange-900",
  [InventoryAdjustmentStatus.Completed]: "bg-tertiary-green-100 text-tertiary-green-700",
  [InventoryAdjustmentStatus.PartiallyFailed]: "bg-secondary-200 text-secondary-600",
  [InventoryAdjustmentStatus.Failed]: "bg-secondary-100 text-secondary-700",
} as const
